/** core libraries & third party packages */
import React from "react";
import { Link } from "react-router-dom";

/** icons */
import { MdArrowOutward } from "react-icons/md";

/** component */
import HomeProductCard from "../../components/common/product-card/HomeProductCard";

/** custom hooks & query & context */
/** utils */

/** style */
import "./Home.scss";

/** interfaces */

const Home: React.FC = () => {
  return (
    <div className="home_page">
      <div className="home_page_container">
        <div className="home_banner_container">
          <h1 className="banner_title">
            Do it <span>right</span>
          </h1>
          <div className="banner_img">
            <img
              src="/assets/home/banner-1.webp"
              alt="banner"
              loading="eager"
              decoding="async"
              height={300}
              fetchPriority="high"
            />
            <div className="absolute top-0 translate-y-[150px] left-[-85px] rotate-[-90deg] lg:block hidden">
              <div className="bg-[#232321] p-4 text-white text-[17px] font-medium rounded-[0px_0px_20px_20px]">
                Nike product of the year{" "}
              </div>
            </div>
            <div className="banner_image_content">
              <div className="banner_image_title">NIKE AIR MAX</div>
              <div className="banner_image_desc">
                Nike introducing the new air max for everyone's comfort
              </div>
              <Link to={"/products"}>
                <button type="submit" className="shop_now_btn">Shop now</button>
              </Link>
            </div>
          </div>
        </div>

        <div className="new_arrivals w-[96%]">
          <div className="new_arrivals_header">
            <div className="left_side_content_heading">
              Don’t miss out <br /> new drops
            </div>
            {/* <button type="button" className="shop_now_btn">Shop New Drops</button> */}
          </div>
          {/* <SpecialProduct /> */}
          <HomeProductCard />
          <Link to={"/products"}>
            <div className="view_all_btn">
              <div className="btn">
                <p>View All</p>
              </div>
            </div>
          </Link>
        </div>

        <hr />
        <div className="shop_by_category_section">
          <div className="shop_by_categories w-[96%]">
            <div className="flex justify-between items-center">
              <div className="shop_by_categories_text">Categories</div>
              {/* <div className="flex items-center gap-[10px]">
                <div className="bg-[#E7E7E3] text-[#232321] rounded-[10px] w-[40px] h-[40px] flex justify-center items-center cursor-pointer">
                  <MdKeyboardArrowLeft size={22} />
                </div>
                <div className="bg-[#E7E7E3] text-[#232321] rounded-[10px] w-[40px] h-[40px] flex justify-center items-center cursor-pointer">
                  <MdKeyboardArrowRight size={22} />
                </div>
              </div> */}
            </div>
          </div>
          <div className="categories_slider">
            <div className="sm:w-[50%] w-[100%] relative">
              <div className="flex justify-center items-center select-none">
                <img
                  src="/assets/products/product-transparent-1.webp"
                  alt=""
                  loading="lazy"
                  width={440}
                  height={300}
                />
              </div>
              <div className=" absolute bottom-0 left-0 flex justify-between px-[20px] lg:px-[50px] py-[40px] items-center w-full">
                <div className="sm:text-[36px] text-[25px] font-medium uppercase sm:leading-10 leading-7">
                  Lifestyle <br />
                  Shoes
                </div>
                <div className="bg-[#232321] hover:bg-[#E7E7E3] hover:text-[#232321] duration-500 text-[#E7E7E3] rounded-[10px] sm:w-[50px] sm:h-[50px] w-[40px] h-[40px] flex justify-center items-center cursor-pointer">
                  <MdArrowOutward size={28} />
                </div>
              </div>
            </div>
            <div className="sm:w-[50%] w-[100%] relative">
              <div className="flex justify-center items-center select-none">
                <img
                  src="/assets/products/product-transparent-2.webp"
                  alt=""
                  loading="lazy"
                  width={410}
                  height={300}
                />
              </div>
              <div className=" absolute bottom-0 left-0 flex justify-between px-[20px] lg:px-[50px] py-[40px] items-center w-full">
                <div className="sm:text-[36px] text-[28px] font-medium uppercase sm:leading-10 leading-7">
                  Basketball <br />
                  Shoes
                </div>
                <div className="bg-[#232321] hover:bg-[#E7E7E3] hover:text-[#232321] duration-500 text-[#E7E7E3] rounded-[10px] sm:w-[50px] w-[40px] sm:h-[50px] h-[40px] flex justify-center items-center cursor-pointer">
                  <MdArrowOutward size={28} />
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* <section>
          <Reviews />
        </section> */}
      </div>
    </div>
  );
};

export default Home;
